import { breakpointKeys } from "./Breakpoints";
import { ResponsiveProp, UIBreakpoint } from "./types";

export const isResponsiveObject = <T>(
  val: ResponsiveProp<T>
): val is Partial<Record<UIBreakpoint, T>> => {
  if (typeof val !== 'object' || val === null) return false;

  return Object.keys(val).every(key => breakpointKeys.includes(key as UIBreakpoint));
}